module.exports = __webpack_public_path__ + "75f6e53d9e1e9defbb5f728c7edddf7f.png";